import { memo, type FC } from "react";
import { Sparkles } from "lucide-react";
import { useSegmentLabel } from "../../UseSegmentLabel";
import type { SegmentPromptState } from "../../UseSegmentPrompt";
import PromptComposer from "./PromptComposer";
import PromptFeedback from "./PromptFeedback";

interface SegmentPromptPanelProps {
  prompt: SegmentPromptState;
}

const SegmentPromptPanel: FC<SegmentPromptPanelProps> = ({ prompt }) => {
  const label = useSegmentLabel();

  return (
    <section className="segment-prompt" aria-label={label("prompt.title")}>
      <header className="segment-prompt__header">
        <Sparkles className="segment-prompt__icon" size={20} aria-hidden />
        <h2 className="segment-prompt__title">{label("prompt.title")}</h2>
        <span className="segment-prompt__subtitle">{label("prompt.subtitle")}</span>
      </header>
      <PromptComposer
        text={prompt.text}
        tokens={prompt.analysis.tokens}
        suggestion={prompt.analysis.suggestion}
        canFill={prompt.canFill}
        onTextChange={prompt.setText}
        onFill={prompt.fill}
        onAcceptSuggestion={prompt.acceptSuggestion}
      />
      <PromptFeedback
        text={prompt.text}
        analysis={prompt.analysis}
        hasIssues={prompt.hasIssues}
        filledCount={prompt.filledCount}
        onTry={prompt.setText}
        onUndo={prompt.undo}
        onResolveClarification={prompt.resolveClarification}
      />
    </section>
  );
};

export default memo(SegmentPromptPanel);
